<template>
  <div class="w-full flex items-center flex-col relative">
    <div class="relative">
      <img v-if="imageUrl" :src="imageUrl" alt="Image" class="object-cover object-center h-56 w-56">
      <button v-if="showDeleteButton" type="button" @click="$emit('deleteImage')" class="bg-white group border border-coral-400 hover:bg-coral-400 rounded-full absolute top-0 right-0 -mt-4 -mr-4">
        <icon name="x" class="w-8 h-8 text-coral-400 group-hover:text-white fill-current"></icon>
      </button>
      <button v-if="!value" type="button" @click="browse" class="bg-white group border border-gray-600 rounded-full absolute bottom-0 right-0 -mb-4 -mr-4">
        <icon name="pencil" class="w-8 h-8 text-gray-600 group-hover:text-gray-500 fill-current"></icon>
      </button>
    </div>

    <div class="form-input p-0" :class="{ error: dataError }">
      <input ref="file" type="file" accept="image/*" class="hidden" @change="change">

      <div v-if="value" class="flex flex-col p-2 mt-4">
        <div class="mb-2 text-center">{{ value.name }} <span class="text-grey-dark text-sm">({{ filesize(value.size) }})</span>
        </div>
        <button type="button" class="btn-secondary outlined" @click="remove">
          {{ __("Cancel") }}
        </button>
      </div>
    </div>
    <div v-if="dataError" class="form-error">{{ dataError }}</div>
  </div>
</template>

<script>
  import Icon from '@/Shared/Icon';

  export default {
    props: {
      imageUrl: {
        type: String,
        default() {
          return this.$page.props.config.defaultImageUrl;
        }
      },
      showDeleteButton: Boolean,
      value: File,
      dataError: String
    },
    components: {Icon},
    watch: {
      value(value) {
        if (!value) {
          this.$refs.file.value = ''
        }
      },
    },
    methods: {
      filesize(size) {
        let i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      },
      browse() {
        this.$refs.file.click()
      },
      change(e) {
        this.$emit('input', e.target.files[0])
      },
      remove() {
        this.$emit('input', null)
      },
    },
  }
</script>
